/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiSanctionClearanceSandboxEntityType {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION',
    RFI = 'RFI'
}


export function instanceOfApiSanctionClearanceSandboxEntityType(value: any): boolean {
    for (const key in ApiSanctionClearanceSandboxEntityType) {
        if (Object.prototype.hasOwnProperty.call(ApiSanctionClearanceSandboxEntityType, key)) {
            if (ApiSanctionClearanceSandboxEntityType[key as keyof typeof ApiSanctionClearanceSandboxEntityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiSanctionClearanceSandboxEntityTypeFromJSON(json: any): ApiSanctionClearanceSandboxEntityType {
    return ApiSanctionClearanceSandboxEntityTypeFromJSONTyped(json, false);
}

export function ApiSanctionClearanceSandboxEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionClearanceSandboxEntityType {
    return json as ApiSanctionClearanceSandboxEntityType;
}

export function ApiSanctionClearanceSandboxEntityTypeToJSON(value?: ApiSanctionClearanceSandboxEntityType | null): any {
    return value as any;
}

export function ApiSanctionClearanceSandboxEntityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiSanctionClearanceSandboxEntityType {
    return value as ApiSanctionClearanceSandboxEntityType;
}

